import React, { useEffect, useState } from "react";

import { getAdminFrontendAddons } from "@/api/admin/frontendAddons";
import { usePageTitleEffect } from "@/components/AppProvider/AppOrgsAndInvitedOrgsProvider";
import { GridTableFrontendAddons } from "@/components/GridTable/GridTableFrontendAddons";
import { FrontendAddonWithTargetVersionRaw } from "@/domain/FrontendAddon";
import { useAppAccount } from "../../components/AppProvider/AppAccountProvider";
import { AppTopNavSlot } from "../../components/AppTopNav";
import { LoadingCover } from "../../components/LoadingCover";
import { getIsAAAdminOrAbove } from "../../domain/Account";
import styles from "../index.module.css";

export const PageAdminFrontendMasters: React.FC = () => {
  const { account } = useAppAccount();

  const [{ frontendAddons, isLoadedFrontendAddons }, setFrontendAddons] =
    useState<{
      frontendAddons: FrontendAddonWithTargetVersionRaw[];
      isLoadedFrontendAddons: boolean;
    }>({
      frontendAddons: [],
      isLoadedFrontendAddons: false,
    });

  const runReloadFrontendAddons = async () => {
    setFrontendAddons({
      frontendAddons: [],
      isLoadedFrontendAddons: false,
    });
    const frontendAddons = await getAdminFrontendAddons({});
    setFrontendAddons({
      frontendAddons,
      isLoadedFrontendAddons: true,
    });
  };

  useEffect(() => {
    runReloadFrontendAddons();
    return () => {
      setFrontendAddons({
        frontendAddons: [],
        isLoadedFrontendAddons: false,
      });
    };
  }, []);

  usePageTitleEffect("フロントエンドアドオンマスタ");

  return (
    <div className={styles.root}>
      <div>
        <AppTopNavSlot>
          <div className={styles.titleFlexContainer}>
            <div className={styles.title}>フロントエンドアドオンマスタ</div>
          </div>
        </AppTopNavSlot>
      </div>
      <div className={styles.pageContent}>
        {!account ? (
          <LoadingCover />
        ) : getIsAAAdminOrAbove(account) ? (
          <GridTableFrontendAddons
            {...{
              isLoadedFrontendAddons,
              frontendAddons,
              runReloadFrontendAddons,
              returnPath: `/admin/frontendmasters`,
              showSearch: true,
            }}
          />
        ) : (
          <div>管理者権限がありません</div>
        )}
      </div>
    </div>
  );
};
